import React, { Component } from "react";
import LabClinicListView from "./LabClinicListView";
import { history } from "../../../helpers";

export default class LabClinicListContainer extends Component {
  /**
   * @function  navigateToClinicDetails
   * @param "e","clinicId"
   * @description This function redirect the user to clinic-details
   */
  navigateToClinicDetails = (e, clinicId) => {
    e.preventDefault();
    history.push(`/clinics-details/${clinicId}/basic-details`);
  };

  render() {
    const { details } = this.props;

    return (
      <>
        {details && (
          <LabClinicListView
            details={details}
            navigateToClinicDetails={this.navigateToClinicDetails}
          />
        )}
      </>
    );
  }
}
